import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-homepage-four',
    templateUrl: './homepage-four.component.html',
    styleUrls: ['./homepage-four.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomepageFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
